import Vue, { computed, getCurrentInstance } from 'vue'
import { VueConstructor } from 'vue/types/umd'

export function useVuetify(): any {
  const instance = getCurrentInstance()
  const vm =
    instance?.proxy ||
    (instance as unknown as InstanceType<VueConstructor>) ||
    new Vue({})
  return vm?.$vuetify
}

export function isWrapperClient(): any {
  return androidWrapperClient || iosWrapperClient
}
export function androidWrapperClient(): any {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return userAgent == 'cdn-android-wrapper-app'
}
export function iosWrapperClient(): any {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return userAgent == 'cdn-ios-wrapper-app'
}
export function ios(): any {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return iosWrapperClient || /iphone|ipad|ipod/.test(userAgent)
}
export function android(): any {
  const userAgent = window.navigator.userAgent.toLowerCase()
  return androidWrapperClient || /android/.test(userAgent)
}
export function standalone(): any {
  if (window.matchMedia('(display-mode: standalone)').matches) return true
  const navigator: any = window.navigator
  return 'standalone' in navigator && navigator.standalone
}